export const cssVariableName = (tokenName: string): string =>
  `--${tokenName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`;

export const cssVariable = (tokenName: string): string =>
  `var(${cssVariableName(tokenName)})`;
